let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bV9XV")).then(() => parcelRequire('4yTP0'));